import { useEffect, useContext } from "react";
import { _hoursDetailed, Hours } from "../utils/utils";
import { Store } from "../types.d";
import { Link } from "gatsby";
import { FindAStoreContext } from "../../../../cobra-find-a-store/src/contexts/findAStore";
import { parseStoreHours } from "../utils/storeHours";
import StoreOpenClose from "./open-close";
import { Icon } from "../utils/Icons";

export interface StoreListProps {
  brands: string[];
}
export const StoreList = (props: StoreListProps) => {
  const {
    state: { activeStore, storesInView },
    dispatch,
  } = useContext(FindAStoreContext);
  const setActiveStore = (id: number) =>
    dispatch({ type: "SetActiveStore", payload: id });

  useEffect(() => {
    const elem = document.getElementById("store-active");
    if (elem !== null && activeStore && storesInView.length !== 0) {
      if (storesInView.find((store: Store) => store.id == activeStore)) {
        elem.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  });

  return (
    <div>
      {storesInView.map((store: Store) => {
        const hoursDetailed =
          store.hours == "Coming Soon"
            ? null
            : parseStoreHours(store.hours ?? "");
        const isChangingToLd =
          store?.name === "LendDirect" ||
          store?.city?.state?.name === "New Brunswick";

        return (
          <Link
            to={`/find-a-store/${store.city?.state?.urlSafeName}/${store.city?.urlSafeName}/${store.url}/`}
            key={store.id}
          >
            <div
              role="button"
              tabIndex={0}
              id={store.id === activeStore ? "store-active" : ""}
              onClick={() =>
                activeStore !== store.id ? setActiveStore(store.id) : void 0
              }
              onKeyUp={(e) =>
                e.key == "Enter" && activeStore !== store.id
                  ? setActiveStore(store.id)
                  : void 0
              }
              sx={{
                width: "100%",
                p: "15px 0 15px 20px",
                borderBottom: "solid 1px #ccc",
                ":hover": {
                  backgroundColor: isChangingToLd
                    ? "#FF8600"
                    : store.cashless
                    ? "#6DC3EA"
                    : "#fbfbfb",
                },
                backgroundColor: isChangingToLd
                  ? "#FF8600"
                  : store.cashless
                  ? "#6DC3EA"
                  : store.id === activeStore
                  ? "#f1f1f1"
                  : "",
              }}
            >
              <div
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                {!isChangingToLd ? (
                  <div
                    sx={{
                      flexGrow: 10,
                      marginRight: "20px",
                    }}
                  >
                    {store.cashless && (
                      <p
                        sx={{
                          marginBottom: "0px",
                          marginTop: "0px",
                          fontSize: "0.95rem",
                        }}
                      >
                        Cashless
                      </p>
                    )}
                    <h5
                      sx={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "22px",
                        fontFamily: "heading",
                      }}
                    >
                      {store.crossStreets}
                    </h5>
                    <p
                      sx={{
                        marginBottom: "0px",
                        marginTop: "0px",
                        fontSize: "0.95rem",
                      }}
                    >
                      {hoursDetailed && (
                        <StoreOpenClose
                          store={store}
                          hoursDetailed={hoursDetailed}
                        />
                      )}
                    </p>
                  </div>
                ) : (
                  <div
                    sx={{
                      flexGrow: 10,
                      marginRight: "20px",
                    }}
                  >
                    {" "}
                    <h5
                      sx={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "22px",
                        fontFamily: "heading",
                      }}
                    >
                      {store.crossStreets}
                    </h5>
                    <p
                      sx={{
                        marginBottom: "0px",
                        marginTop: "0px",
                        fontSize: "0.95rem",
                      }}
                    >
                      This is Now a LendDirect Branch
                    </p>
                  </div>
                )}
                <div
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <div
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      flexShrink: 0,
                      justifyContent: "flex-end",
                      alignContent: "center",
                      justifyItems: "center",
                      "& img": {
                        width: "28px",
                      },
                    }}
                  >
                    <div
                      sx={{
                        textAlign: "center",
                        px: "0px",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignContent: "center",
                        flexShrink: 0,
                        fontSize: "24px",
                        "& svg": {
                          cursor: "pointer",
                          color: "#00502f",
                        },
                      }}
                    >
                      <Icon
                        alt="Store Details"
                        name="chevron-down"
                        height={24}
                        width={24}
                        viewBox="0 0 30 30"
                        fill="brand.black"
                        tabIndex={0}
                        sx={{
                          mt: 10,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default StoreList;
